import { render, staticRenderFns } from "./PageUsersPricesSettings.vue?vue&type=template&id=6dfa5ffe&scoped=true&"
import script from "./PageUsersPricesSettings.vue?vue&type=script&lang=js&"
export * from "./PageUsersPricesSettings.vue?vue&type=script&lang=js&"
import style0 from "./PageUsersPricesSettings.vue?vue&type=style&index=0&id=6dfa5ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa5ffe",
  null
  
)

export default component.exports